import React from 'react'

const SonyPXW4504kUHDShouldercamcorder = () => {
  return (
    <div>SonyPXW4504kUHDShouldercamcorder</div>
  )
}

export default SonyPXW4504kUHDShouldercamcorder